import * as authRoutines from '../Containers/Auth/authRoutines';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { rsf } from '../globals/firebase';

export function* firebaseAuthenticationSaga(action) {
    try {
        let user = yield call(rsf.auth.signInWithCustomToken, action.payload);
        yield put(authRoutines.firebaseAuthentication.success(user));
    } catch (error) {
        yield put(authRoutines.firebaseAuthentication.failure(error));
        throw error;
    }
}

function* firebaseSignout() {
    try {
        yield call(rsf.auth.signOut);
        yield put(authRoutines.firebaseSignout.success());
    } catch (error) {
        yield put(authRoutines.firebaseSignout.failure(error));
    }
}

export default function* fbLoginRootSaga() {
    yield all([
        takeEvery(authRoutines.firebaseAuthentication.TRIGGER, firebaseAuthenticationSaga),
        takeEvery(authRoutines.firebaseSignout.TRIGGER, firebaseSignout),
    ]);
}
